import {ModelBase} from "FormBuilder/Core/Models/ModelBase";
import {StoreBase} from "shared/core/Store/StoreBase";


export abstract class ModelWithParent<Op extends StoreBase,P=any> extends ModelBase<Op>{
    public Parent:P;
    constructor(Options:Op, Parent:P)
    {
        super(Options);
        this.Parent=Parent;
    }
}